module.exports = __webpack_public_path__ + "img/df8716c9-6502-4356-8f4c-60ca357c0630.c1e13625.png";